<div class="modal">
  <div class="modal-content">
    <div class="modal-title">
      <h4 class="title">
        <span class="icon-Company-Assigned"></span>
        <span class="title-text">Seleccionar una empresa</span>
      </h4>
      <div class="modal-close">
        <button type="button" (click)="cancel()">&#10799;</button>
      </div>
    </div>

    <div class="modal-body">
      <form [formGroup]="form" autocomplete="off">
        <ng-select
          placeholder="Selecciona una empresa"
          formControlName="company"
        >
          <ng-option *ngFor="let company of companies" [value]="company.id">
            {{ company.name }}
          </ng-option>
        </ng-select>

        <div class="add-company">
          <span class="icon-Add"></span>
          <p class="body-2" (click)="openCompany()">Agregar nueva empresa</p>
        </div>

        <div class="container-button">
          <button class="btn-filled" type="submit" (click)="submit()">
            Guardar
          </button>
          <button class="btn-without-filled" (click)="cancel()">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
